import { useState } from "react"
import styled from "styled-components"
import Cookies from 'js-cookie'
import { Button, Checkbox, Modal, TextInput } from "@prosolve/common-components-ui"

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
`

const Footer = styled.div`
  display: flex;
  padding: 10px;
  justify-content: flex-end;
`

const FieldWrapper = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`

const FieldLabel = styled.span``

export default ({
  data,
  onClose,
  onSuccess
}) => {
  const [email, setEmail] = useState(Cookies.get('email') )
  const [isSkipRecordUpdate, setIsSkipRecordUpdate] = useState(true)

  const handleClick = () => {
    if (email?.trim()?.length === 0) {
      alert('email is required')

    } else {
      onSuccess({
        ...data,
        email,
        isSkipRecordUpdate
      })
      onClose()
    }
  }

  return (
    <Modal title='Test Run' isAutoHeight={true} isAutoWidth={true} onClose={onClose} footer={
      <Footer>
        <Button $colored={true} onClick={handleClick}>Run</Button>
      </Footer>
    }>
      <Contents>
        <FieldWrapper>
          <FieldLabel>Email*: </FieldLabel>
          <TextInput type='email' placeholder='email@prosolve.com' value={email} onChange={setEmail} />
          </FieldWrapper>
        <Checkbox label='Is Skip Record Update' value={isSkipRecordUpdate} onChange={(e) => setIsSkipRecordUpdate(e.target.checked)}  />
      </Contents>
    </Modal>
  )
}
